import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM21.41 6.34l-3.75-3.75-2.53 2.54 3.75 3.75 2.53-2.54z"
}), 'EditSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EditSharp.js
// module id = 3316
// module chunks = 2